import React from 'react';
import { Instagram, Linkedin, Twitter } from 'lucide-react';
export function Footer() {
  return <footer className="bg-white pt-20 pb-10 border-t border-slate-100" data-id="element-76">
      <div className="container mx-auto px-6 md:px-12" data-id="element-77">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-78">
          {/* Brand */}
          <div className="lg:col-span-1" data-id="element-79">
            <img src="https://cdn.magicpatterns.com/uploads/xq3A4qTnhBr3i72N1qfHwy/Nicova_Digital_horizontal_logo,_abstract_geometric_N_symbol_on_the_left_in_black_with_turquoise_cyan_accents,_company_name_NICOVA_DIGITAL_on_the_right_in_black_typography,_white_background,_modern_sans-serif_typefac.jpg" alt="Nicova Digital Logo" className="h-10 mb-6 object-contain" data-id="element-80" />
            <p className="text-slate-500 text-sm leading-relaxed mb-6" data-id="element-81">
              Agencia de marketing digital especializada en crecimiento B2B
              mediante automatización, IA y estrategias basadas en datos.
            </p>
            <div className="flex gap-4" data-id="element-82">
              <a href="#" className="w-10 h-10 rounded-full bg-slate-50 flex items-center justify-center text-slate-400 hover:bg-brand-cyan hover:text-white transition-colors" data-id="element-83">
                <Linkedin size={18} data-id="element-84" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-slate-50 flex items-center justify-center text-slate-400 hover:bg-brand-cyan hover:text-white transition-colors" data-id="element-85">
                <Twitter size={18} data-id="element-86" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-slate-50 flex items-center justify-center text-slate-400 hover:bg-brand-cyan hover:text-white transition-colors" data-id="element-87">
                <Instagram size={18} data-id="element-88" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div data-id="element-89">
            <h4 className="font-bold text-brand-black mb-6" data-id="element-90">Servicios</h4>
            <ul className="space-y-3" data-id="element-91">
              {['Google Ads', 'CRM', 'IA para Marketing', 'Google Analytics', 'Remarketing', 'Optimización'].map(item => <li key={item} data-id="element-92">
                  <a href="#" className="text-slate-500 hover:text-brand-cyan text-sm transition-colors" data-id="element-93">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-94">
            <h4 className="font-bold text-brand-black mb-6" data-id="element-95">Empresa</h4>
            <ul className="space-y-3" data-id="element-96">
              {['Nosotros', 'Casos de Éxito', 'Blog', 'Contacto'].map(item => <li key={item} data-id="element-97">
                    <a href="#" className="text-slate-500 hover:text-brand-cyan text-sm transition-colors" data-id="element-98">
                      {item}
                    </a>
                  </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-99">
            <h4 className="font-bold text-brand-black mb-6" data-id="element-100">Contacto</h4>
            <ul className="space-y-3" data-id="element-101">
              <li data-id="element-102">
                <a href="mailto:hola@nicovadigital.com" className="text-slate-500 hover:text-brand-cyan text-sm transition-colors" data-id="element-103">
                  hola@nicovadigital.com
                </a>
              </li>
              <li className="text-slate-500 text-sm" data-id="element-104">Madrid, España</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-100 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-105">
          <p className="text-slate-400 text-sm" data-id="element-106">
            Copyright © 2026 Nicova Digital. Todos los derechos reservados.
          </p>
          <div className="flex gap-6" data-id="element-107">
            <a href="#" className="text-slate-400 hover:text-brand-cyan text-sm transition-colors" data-id="element-108">
              Política de Privacidad
            </a>
            <a href="#" className="text-slate-400 hover:text-brand-cyan text-sm transition-colors" data-id="element-109">
              Términos Legales
            </a>
          </div>
        </div>
      </div>
    </footer>;
}